import { find, get, includes, reduce } from 'lodash';
import { elementBeanListType, FloReducerType } from '../../Flo.types';

const guideFloReducer = {
	setSelectedGuideStep(state: FloReducerType, { payload }: { payload: string }) {
		state.guide.selectedGuideStepId = payload;
	},
	setGuideGalleryImages(
		state: FloReducerType,
		{ payload }: { payload: { [key: string]: string } }
	) {
		state.guide.documentGalleryImages = payload;
	},
	setGuideActiveElement(
		state: FloReducerType,
		{ payload }: { payload: elementBeanListType }
	) {
		state.guide.activeGuideElement = payload;
	},
	setGuideImageLoadStatus(
		state: FloReducerType,
		{
			payload,
		}: {
			payload: {
				id: string;
				value: string;
			};
		}
	) {
		state.guide.imagesState[payload.id] = payload.value;
	},
	setResetSelectedSteps(
		state: FloReducerType,
		{ payload }: { payload: { stepId: string } }
	) {
		state.guide.selectedSteps[get(payload, 'stepId')] = !get(
			state,
			`guide.selectedSteps.${get(payload, 'stepId')}`
		);
	},
	updateSelectedSteps(
		state: FloReducerType,
		{ payload }: { payload: { action: string } }
	) {
		if (get(payload, 'action') === 'unselect_all') {
			state.guide.selectedSteps = {};
			return state;
		}
		state.guide.selectedSteps = reduce(
			state.guide.steps,
			(acc: { [key: string]: boolean }, step) => {
				if (get(payload, 'action') === 'select_all_steps') {
					acc[step.id] = true;
				} else if (get(payload, 'action') === 'select_all_steps_with_images') {
					const imageUrl = get(step, 'imageUrl') || get(step, 'resourceDetail.url');
					acc[step.id] = !!imageUrl;
				} else if (get(payload, 'action') === 'select_all_steps_without_images') {
					const imageUrl = get(step, 'imageUrl') || get(step, 'resourceDetail.url');
					acc[step.id] = !imageUrl;
				}
				return acc;
			},
			{}
		);
	},
	deleteSelectedSteps() {},
	deleteSelectedStepsSuccess(
		state: FloReducerType,
		{ payload: { steps } }: { payload: { steps: string[] } }
	) {
		state.guide.selectedSteps = {};
		const selectedStepId = get(state, 'guide.selectedGuideStepId');
		if (includes(steps, selectedStepId)) {
			const unSelectedStep = find(state.guide.steps, (step) => !includes(steps, step.id));
			state.guide.selectedGuideStepId = get(unSelectedStep, 'id') || '';
		}
		// state.guide.steps = filter(state.guide.steps, (step) => !includes(payload.steps, step.id));
	},
};

export default guideFloReducer;
